import { render, staticRenderFns } from "./Confirmacao.vue?vue&type=template&id=655583ec&scoped=true&"
import script from "./Confirmacao.vue?vue&type=script&lang=js&"
export * from "./Confirmacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655583ec",
  null
  
)

export default component.exports